import AnnualPeriodsError from './AnnualPeriodsError';
class AnnualPeriodsNumberLessThanOne extends AnnualPeriodsError {
    numberOfBricks;
    constructor(numberOfBricks, options) {
        super('The number of bricks can not be less than one', options);
        this.numberOfBricks = numberOfBricks;
    }
}
export default AnnualPeriodsNumberLessThanOne;
